import { Directive, HostListener } from '@angular/core';

import { AbstractModalDirective } from '../../dialog/abstracts';
import { UploadFilesDialogComponent } from '../components/upload-files-dialog/upload-files-dialog.component';

@Directive({
  selector: '[bnWebUiUploadFileDialog]',
})
export class UploadFileDialogDirective extends AbstractModalDirective {
  constructor() {
    super();
  }

  @HostListener('click', ['$event'])
  public clicked(event: Event): void {
    event.preventDefault();

    this.bsModalRef = this.modalService.show(UploadFilesDialogComponent, {
      class: 'modal-dialog-centered',
      ...this.getInputState(),
    });
  }
}
